import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconWarningSign: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconWarningSign"><Path fillRule="evenodd" clipRule="evenodd" d="M6.15943 3H17.8392L22.1549 20.8022L20.6972 21.1556L19.8109 17.5H14.6877L13.8015 21.1556L12.3438 20.8022L13.1443 17.5H4.18773L3.30153 21.1556L1.84375 20.8022L6.15943 3ZM17.2493 6.93336L15.0514 16H19.4473L17.2493 6.93336Z" fill="currentColor"/></CentralIconBase>;
});

export default IconWarningSign;
